module.exports = __webpack_public_path__ + "img/土星.986b5e55.svg";